<div class="bg-ponder-dark min-h-screen w-full overflow-x-hidden flex flex-col items-center"  style="background: linear-gradient(#343346, #1A1922);">
    @if (isLoading) {
        <div class="mt-12"><busy-spin></busy-spin></div>
    } @else {
        <div class="flex flex-col gap-4 items-center justify-center mt-12 mb-12 text-sm text-center p-8 rounded-xl bg-ponder-light shadow w-96">
            @if (upgradeStatus == 0) {
                <div class="font-title text-lg sm:text-xl text-white font-bold">
                    Uh oh! Something went wrong!
                </div>
                <div class="flex flex-col gap-2 text-red-600 text-xs sm:text-sm">
                    <p>{{ errorText ? errorText : "Unknown error. Please try again." }}</p>
                    <p>If this issue persists, <a class="text-red-500 hover:text-red-400" href="/about#contact">please contact us.</a></p>
                </div>
            } @else if (upgradeStatus == 1) {
                <div class="font-title text-lg sm:text-xl text-white font-bold">
                    Your payment is processing.
                </div>
                <div class="flex flex-col gap-2 text-slate-400 text-xs sm:text-sm">
                    <p>This page will automatically update when complete.</p>
                    <p>If you navigate away, your subscription status can be viewed from <a href="/account/billing" class="text-slate-300 hover:text-slate-200">your account settings.</a></p>
                    <busy-spin [bright]="true" class="mt-4"></busy-spin>
                </div>
            } @else if (upgradeStatus == 2) {
                <div class="font-title text-lg sm:text-xl text-white font-bold">
                    Upgrade Success!
                </div>
                <div class="flex flex-col gap-2 text-slate-400 text-xs sm:text-sm">
                    <p>Thank you for your support!</p>
                    <p>Your subscription can be viewed and modified at anytime from <a href="/account/billing" class="text-slate-300 hover:text-slate-200">your account settings.</a></p>
                </div>
            }
        </div>
    }
</div>